// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1___fe824c7c05cdcc59266","cls2":"Base-cls2___ee6fd1ab13a40d90a10 Base-cls1___fe824c7c05cdcc59266"};